<section class="irrigator-auth-panel" aria-labelledby="irrigator-auth-title">
  <button type="button" class="auth-back" (click)="backToProfileSelection()">
    <svg viewBox="0 0 24 24" aria-hidden="true">
      <path d="m15 18-6-6 6-6" />
    </svg>
    Volver
  </button>

  <div class="login-copy">
    <p class="login-kicker">Acceso de comuneros</p>
    <h1 id="irrigator-auth-title">Autenticacion de comunero</h1>
  </div>

  <div class="auth-methods" role="tablist" aria-label="Metodo de autenticacion">
    <button
      type="button"
      [class.active]="irrigatorAuthMethod === 'receipt'"
      (click)="irrigatorAuthMethod = 'receipt'"
    >
      Recibo de cequiaje
    </button>
    <button
      type="button"
      [class.active]="irrigatorAuthMethod === 'certificate'"
      (click)="irrigatorAuthMethod = 'certificate'"
    >
      Certificado digital
    </button>
  </div>

  @if (irrigatorAuthMethod === 'receipt') {
    <form class="receipt-auth-form" (submit)="authenticateIrrigatorByReceipt($event)">
      <label>
        <span>Codigo indicado en el documento de pago</span>
        <input
          type="text"
          name="ticketCode"
          [(ngModel)]="ticketCode"
          maxlength="8"
          autocomplete="off"
          placeholder="Ej. A1B2C3D4"
        />
      </label>

      <label>
        <span>Importe del recibo</span>
        <input
          type="text"
          name="receiptAmount"
          [(ngModel)]="receiptAmount"
          inputmode="decimal"
          autocomplete="off"
          placeholder="Ej. 125,40"
        />
        <small class="field-help">No es necesario indicar separadores de millares.</small>
      </label>

      @if (irrigatorAuthError) {
        <p class="auth-error" role="alert">{{ irrigatorAuthError }}</p>
      }

      <button type="submit" class="auth-submit" [disabled]="irrigatorAuthLoading">
        {{ irrigatorAuthLoading ? 'Comprobando...' : 'Acceder como comunero' }}
      </button>
    </form>
  } @else {
    <section class="certificate-auth">
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 22s7-3.2 7-10V5l-7-3-7 3v7c0 6.8 7 10 7 10Z" />
        <path d="m9 12 2 2 4-5" />
      </svg>
      <h2>Autenticacion con certificado digital</h2>
      <p>Se abrirá el acceso seguro para validar el certificado digital del comunero.</p>
      <a class="auth-submit" [href]="digitalCertificateAuthUrl">
        Acceder con certificado
      </a>
    </section>
  }
</section>
